import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Teaching beginners",
  "description": "",
  "published": "2016-08-19T00:00:00.000Z",
  "redirect_from": ["/blog/teaching-beginners/swizec/6943"],
  "categories": "Learning, Personal",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`On Monday I built `}<a parentName="p" {...{
        "href": "https://swizec.com/blog/conways-game-of-life-in-google-docs/swizec/6931"
      }}>{`Conway’s Game of Life in Google Docs`}</a>{`. Prep work for a short talk given to the non-technical part of our team at `}<a parentName="p" {...{
        "href": "https://www.yup.com/"
      }}>{`Yup`}</a>{`. It was supposed to make it fun and easy to show everyone how to make their own lives easier.`}</p>
    <p><em parentName="p">{`“Is this how you hack websites?”`}</em>{` `}{`<`}{`- first question`}</p>
    <p>{`Nope. Not easy.`}</p>
    <p>{`Everyone loved the game of life. They grokked that complex patterns emerge from four simple rules. They could see the beauty in that. They loved the Wikipedia gifs of gliders and oscillators and other things people have built in Life.`}</p>
    <p><em parentName="p">{`“This is a boring game, man. Not only is it slow, but you’re playing it in a spreadsheet.”`}</em></p>
    <p>{`That was a fair point. The lack of timers in gDocs `}<em parentName="p">{`does`}</em>{` make the game tedious to play and not many people associate spreadsheets with fun. I’m sure they exist, I just haven’t met them yet.`}</p>
    <p>{`Nobody grokked how implementing a silly game from 1970 translates to something practical. The conceptual leap from `}<em parentName="p">{`“You can manipulate cells to make patterns”`}</em>{` to `}<em parentName="p">{`“You can automate common tasks”`}</em>{` proved too hard.`}</p>
    <p>{`I should have seen that coming.`}</p>
    <p>{`Translating one problem to another is `}<strong parentName="p">{`the hardest thing in software`}</strong>{`. Like, the hardest and most hardcorest of things. It took 4 years of hard computer science before somebody showed me how to formally prove that one problem is the same as another.`}</p>
    <p>{`I expected everyone to get it the first time they saw some code. That was dumb.`}</p>
    <p>{`Seeing the potential in a technique isn’t quite as hard as proving that two problems are the same, but it’s still hard. My whole life consists of:`}</p>
    <ol>
      <li parentName="ol">{`See problem`}</li>
      <li parentName="ol">{`Find 1 of N common patterns that solves it`}</li>
      <li parentName="ol">{`Adapt solution to problem`}</li>
    </ol>
    <p><strong parentName="p">{`^ this is why experience matters ^`}</strong></p>
    <p>{`Most people’s lives don’t look like that. I should have used a tangible example and that would make the presentation better and also miss the core tenet of coding.`}</p>
    <p>{`From that point onward, the presentation was a train wreck.`}</p>
    <p>{`You say variable. Their eyes glaze over. 3 people explain it because they’ve taken JavaScript classes or they’re engineers. Each has a different explanation.`}</p>
    <p>{`You say function, their eyes glaze over. 3 people explain it. Each words it differently.`}</p>
    <p>{`You say object, their eyes … you get the picture.`}</p>
    <p>{`You say loop … yeah …`}</p>
    <p>{`I never realized how much jargon programmers use. How much jargon `}<em parentName="p">{`I`}</em>{` use in my own head! Concepts I don’t even realize are jargon. Can I even sound like a normal person anymore?`}</p>
    <p>{`Like, how do you explain an object? It’s an object. It’s a word that exists in the English language and has the same meaning both in English and in JavaScript.`}</p>
    <p>{`But people don’t think of objects as bags of methods and properties. Programmers do.`}</p>
    <p>{`It was like culture shock from hell. We couldn’t even find a common language to speak in. The whole thing was a mess.`}</p>
    <p>{`I didn’t teach anyone how to code who didn’t know how to code before my talk. I don’t even think I excited anyone about learning more. My presentation didn’t make anyone feel empowered.`}</p>
    <p>{`At most I managed to convince everyone that programming is an impenetrable arcane magic known only to a select few.`}</p>
    <p>{`My job security is now safe. Perhaps too safe.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      